import { Inject, Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize, map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SessaoDiariaService {
  private http: HttpClient;
  private chave = '';
  private ate = 0;
  private pendente: Observable<boolean> = null;
  constructor(backend: HttpBackend, @Inject('BASE_URL') private baseUrl: string) {
    // A validacao nao passa pelo interceptor que depende dela.
    this.http = new HttpClient(backend);
  }

  identidade(): string {
    return JSON.stringify([localStorage.getItem('id'), localStorage.getItem('guidclientenapis'), localStorage.getItem('login_diario_token')]);
  }

  validar(): Observable<boolean> {
    const id = Number(localStorage.getItem('id'));
    const empresa = localStorage.getItem('guidclientenapis');
    if (!(id > 0) || !empresa) return of(false);
    const chave = this.identidade();
    if (chave === this.chave) {
      if (this.pendente) return this.pendente;
      if (performance.now() < this.ate) return of(true);
    }
    this.chave = chave;
    this.ate = 0;
    const inicio = performance.now();
    const request = this.http.post<{ valida: boolean; forcar_login: boolean; validade_segundos: number }>(
      this.baseUrl + 'api/Sessao/ValidarDia', { usuarioId: id, empresa, token: localStorage.getItem('login_diario_token') }
    ).pipe(map(resultado => {
      if (this.identidade() !== chave) return false;
      localStorage.setItem('forcar_login', String(resultado.forcar_login));
      if (resultado.valida) this.ate = inicio + Math.max(0, resultado.validade_segundos * 1000);
      return resultado.valida;
    }), catchError(error => error.status === 401 ? of(false) : throwError(() => error)),
      finalize(() => { if (this.chave === chave) this.pendente = null; }), shareReplay({ bufferSize: 1, refCount: false }));
    this.pendente = request;
    return request;
  }
}
